import qs from 'qs';
import axios from 'axios';
import { getEnv } from 'business-layer/helpers/env';
import { fetchBaseUrl } from 'data-layer/fetch-api/fetchBaseUrl';


//TODO: define later if needed.
const config = {};
const requestInterceptors: any[] = [];
const responseInterceptors: any[] = [];

const fetchInstance = axios.create(config);

requestInterceptors.forEach((interceptor: any) => {
  fetchInstance.interceptors.request.use(interceptor);
});
responseInterceptors.forEach((interceptor: any) => {
  fetchInstance.interceptors.response.use(interceptor);
});

const fetch = async (
  instance: any,
  url: any,
  data: any,
  options: Record<string, unknown> = {},
) => {
  const env = getEnv();
  const opts = {
    method: 'POST',
    headers: {
      ...((options.apiVersion === 2) ? {'content-type': 'application/json'} : {'content-type': 'application/x-www-form-urlencoded'}),
      'x-request-env': env,
    },
    signal: null,
    ...options,
  };

  if (!instance.defaults.baseURL) {
    instance.defaults.baseURL = (await fetchBaseUrl((options as any).hash, false))!;
  }

  const response = await (instance as any).request({
    headers: opts.headers,
    url,
    method: opts.method,
    data: (options.apiVersion === 2) ? data : qs.stringify(data || {}),
    signal: opts.signal,
  });
  return response;
}

export { fetchInstance, fetch };
export const abortController = new AbortController();
